import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import { createDepartment } from "../api/coreApi";
import { fkId } from "../utils/coreHelpers";

export default function DepartmentFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  goNext,
  hospitals = [],
  selectedHospitalId,
  setSelectedHospitalId,
}) {
  if (!hospitals.length) return <Alert severity="info">Create Hospital first (Step 1).</Alert>;

  const hospitalOptions = hospitals.map((h) => ({
    value: fkId(h.hospital_id || h.id),
    label: `${h.name} (${h.city || "-"})`,
  }));

  const onSubmit = async (vals, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const payload = {
        organization: selectedHospitalId,
        name: vals.name,
        code: vals.code,
        is_active: vals.is_active,
      };

      await createDepartment(payload);

      goNext();
      await refreshAll();
      helpers?.reset?.();
    } catch (e) {
      setErr(e?.response?.data ? JSON.stringify(e.response.data) : "Create department failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 5: Department</Typography>

      <EntityForm
        title="Create Department"
        loading={loading}
        initialValues={{
          _hospital: selectedHospitalId || hospitalOptions[0]?.value || "",
          name: "",
          code: "",
          is_active: true,
        }}
        fields={[
          {
            name: "_hospital",
            label: "Hospital",
            type: "select",
            required: true,
            options: hospitalOptions,
          },
          { name: "name", label: "Department Name", required: true },
          { name: "code", label: "Code (optional)", placeholder: "ICU / CARD" },
          {
            name: "is_active",
            label: "Active",
            type: "select",
            options: [
              { value: true, label: "True" },
              { value: false, label: "False" },
            ],
          },
        ]}
        onSubmit={(vals, helpers) => {
          if (vals._hospital && vals._hospital !== selectedHospitalId) {
            setSelectedHospitalId(vals._hospital);
          }
          return onSubmit(vals, helpers);
        }}
      />
    </Box>
  );
}